import React, { Component } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import { Main2 } from "@/components/layout/Main";
import { redirectOnSignIn } from "@/utils/redirectOnSignIn";
import Workflow from "@/components/Common/Workflow";

class WorkflowRouter extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    redirectOnSignIn(this.props.history);
  }

  render() {
    let baseUrl = this.props.url;

    return (
      <Main2>
        <Switch>
          <Route component={Workflow} path={baseUrl + "/workflow"} />
          <Redirect from={baseUrl} to={baseUrl + "/workflow"} />
        </Switch>
      </Main2>
    );
  }
}

export default withRouter(WorkflowRouter);
